import React from 'react';
import { ArrowsLeftRight, BookOpen, ChatCircleDots, CursorClick, Eye, Flag, Users } from '@phosphor-icons/react';
import type { SignalIcon } from '../../data/signals';
export function SignalGlyph({
  icon,
  size = 19
}: {
  icon: SignalIcon;
  size?: number;
}) {
  if (icon === 'role') return <Users size={size} aria-hidden="true" data-id="element-686" data-mp="1ixagta9d2vf7" />;
  if (icon === 'response') return <ChatCircleDots size={size} aria-hidden="true" data-id="element-687" data-mp="14y13cicjifex" />;
  if (icon === 'association') return <ArrowsLeftRight size={size} aria-hidden="true" data-id="element-688" data-mp="1503zzl8776sm" />;
  if (icon === 'explored') return <Eye size={size} aria-hidden="true" data-id="element-689" data-mp="19yfck3pvnvej" />;
  if (icon === 'completion') return <Flag size={size} aria-hidden="true" data-id="element-690" data-mp="vye9chm54bvw" />;
  if (icon === 'cta') return <CursorClick size={size} aria-hidden="true" data-id="element-691" data-mp="zyofbu9xn2ar" />;
  return <BookOpen size={size} aria-hidden="true" data-id="element-692" data-mp="zz81jn6m8cul" />;
}